module.exports = __webpack_public_path__ + "static/media/14.ae69249f.jpg";